import "slick-carousel";
import * as zoom from "../jquery.zoom.min";
import { isMobile } from "../mobile-check";

export function productSlider(reinit = false) {
  $(".slider--product .slider__slides").each(function() {
    const $this = $(this);

    if (reinit) {
      $this.slick("unslick");
    }

    $this.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: true,
      asNavFor: ".slider--product-thumbs .slider__slides",
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            dots: true
          }
        }
      ]
    });
  });

  $(".slider--product-thumbs .slider__slides").each(function() {
    const $this = $(this);

    if (reinit) {
      $this.slick("unslick");
    }

    $this.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: true,
      asNavFor: ".slider--product .slider__slides",
      focusOnSelect: true
    });
  });

  if (!isMobile()) {
    $(".product--single .image-zoom").each(function() {
      const $this = $(this);
      const $parentSlide = $this.closest(".slider__slide");
      let src = $this.attr("src");
      let $zoomElement;

      if (reinit) {
        const $parentItem = $this.parent();

        $parentItem.parent().html($this);
        $zoomElement = $parentSlide.find(".image-zoom");
      } else {
        $zoomElement = $this;
      }

      $zoomElement
        .wrap('<span style="display:inline-block"></span>')
        .css("display", "block")
        .parent()
        .zoom({
          url: src
        });
    });
  }
}
